export * from './text-avatar.module';
